import { initializeApp } from 'firebase/app';
import { getMessaging, Messaging } from 'firebase/messaging';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDAJmBlXyU-sPhQ56kAqpa1YXnkkEOYwZ0",
  authDomain: "cleaning-committee-syste-1cf4a.firebaseapp.com",
  projectId: "cleaning-committee-syste-1cf4a",
  storageBucket: "cleaning-committee-syste-1cf4a.firebasestorage.app",
  messagingSenderId: "553902746046",
  appId: "1:553902746046:web:97dd51e29a0b8852e9b1ef",
  measurementId: "G-PGYQJK1T0Q"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Cloud Messaging
let messaging: Messaging | null = null;

// Only initialize messaging if supported (browser environment)
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  try {
    messaging = getMessaging(app);
  } catch (error) {
    // Firebase messaging initialization error
  }
}

export { messaging };

// VAPID key for web push notifications
export const VAPID_KEY = "BAMl-7cwaDsNnpYUDm50nnfqGbcuWGlf4CVTo2N1SIURj86DF57WLVL4P9VXIQRZMemAObirEv_y4OYbTK4hF5w";
